import { RedirectToDialogBox } from './redirect-to-dialog-box.enum';

export class RedirectUrls {

    // OrderingMenu
    static createNewOrderUrl = '#/' + RedirectToDialogBox.CreateNewOrder;
    // static expressOrderingUrl = ''; Gets it from Config Values
    static orderFromFavouritesUrl = '#/' + RedirectToDialogBox.OrderFromFavourite;
    static downloadSubmissionFormUrl = 'ordering/create-submission-form';
    static uploadSubmissionFormUrl = 'ordering/submission-form/import-excel';
    static importOrderUrl = 'ordering/import-order';
    static pendingOrdersUrl = 'ordering/orders?status=pending';
    static validatedOrdersUrl = 'ordering/orders?status=validated';
    static viewQuotationsUrl = '#/' + RedirectToDialogBox.ViewQuotations;
    static exportOfferUrl = 'ordering/export-offer';
    static manageProjectsUrl = 'ordering/projects';
    static manageSampleTakerUrl = 'ordering/manage-sample-takers';
    static manageFavouriteSamplesUrl = '#/' + RedirectToDialogBox.ManageFavouriteSamples;
    static manageOrderingConfigurationsUrl = '#/' + RedirectToDialogBox.OrderingConfigurations;
    static manageFavouriteOrdersUrl = 'ordering/manage-favourite-orders';

    // Results Menu
    static myResultsUrl = 'Results';
    static configureResultsViewUrl = 'ResultsConfig/ResultsViewConfig';
    static assignViewsByClientUrl = 'ResultsConfig/ManageClientAssignments';
    static selectInitialViewUrl = 'ResultsConfig/ManageDefaultAssignments';
    static resultsByOrderUrl = 'selfreports/results-by-order';
    static myReportsUrl = 'selfreports/my-reports';
    static defaultReportBuilderUrl = 'selfreports/default-report-builder';
    static reportBuilderUrl = 'selfreports/report-builder';
    static parameterSortingUrl = 'selfreports/custom-parameter-sortings';
    // static testPSortingUrl = ''; not required as part of PBI:2147416
    static limitSetsUrl = 'selfreports/manage-limit-sets';
    static myExportsUrl = 'selfreports/my-exports';
    static myStatisticsUrl = 'selfreports/MyStatistics';
    // static floorPlanUrl = 'selfreports/Floorplan'; not required as part of PBI:2147416
    static standardGraphsUrl = 'selfgraphs';
    static sampleStatusTracking = 'selfreports/sample-status-tracking';
    static monitoringToolUrl = 'selfreports/monitoring-tool';
    // static customReportsUrl = 'SE/Reports/Reports.aspx'; not required as part of PBI:2147416

    // New Results Menu
    // static myResultsNewUrl = ''; Gets it from Config Values
    static manageResultsViewUrl = 'manageResultViews';
    static buildNewResultViewUrl = 'buildNewResultView';

    // Documents Menu
    static sharedDocumentsUrl = 'Documents';
    // static invoicesUrl = 'selfreports/invoices'; not required as part of PBI:2147416

    // DropOff Location
    // static dropOffLocationsUrl = 'DropOffLocations'; not required as part of PBI:2147416

    // Accounts Menu
    static createNewUserUrl = 'account-management#/users/create';
    static manageUsersUrl = 'account-management#/manage-users';

    // Setting Menu
    static configureIterCompanyResultsUrl = 'OperatorTools';
    static manageNewsFeedUrl = 'operator-tools#/manage-newsfeed';
    static createNewPostUrl = 'operator-tools#/create-newsfeed';
    static configureEOLUrl = 'EOLConfiguration';
    static exclusionListUrl = 'SatisfationSurveyExclusionList';

    // Alerts Menu
    static alertsHistoryUrl = 'alerts/alerts-history';
    static myAlertsUrl = 'alerts/my-alerts';

    // Assessment Menu
    static configureAssessmentUrl = 'SelfReports/AssessmentsRuleConfiguration';
    static reassessmentlogsUrl = 'SelfReports/ReassessmentLogs';
    static partialParameters = 'SelfReports/PartialParameters';

    // Imporsonate Menu
    // static impersonateUrl = 'Impersonate'; not required as part of PBI:2147416

    // Lab Contacts Menu
    static manageLabContacts = 'LabContacts#/manage-lab-contacts';
    static uploadLabContactsUrl = 'LabContacts#/upload-lab-contacts';
    static viewLabContactUrl = 'LabContacts#/view-lab-contacts';

    // Support Menu
    static supportUrl = 'Support';
    static advanceSupport = 'AdvancedSupport';

    // User Details Menu
    static yourProfileUrl = 'account-management#/your-profile';
    static editProfileUrl = 'account-management#/edit-profile';
    static customizeMenuUrl = 'CustomizeMenus';
    static termsOfUseUrl = 'TermsOfUse';
    static privacyPolicy = 'PrivacyPolicy';
    static cookiePolicy = 'CookiePolicy';
}
